import { _ } from '@icc/shared/helpers';

export const ComplaintPriorities: Record<number, string> = {
    1: _('COMPLAINT|Pilny'),
    2: _('COMPLAINT|Wysoki'),
    3: _('COMPLAINT|Średni'),
    4: _('COMPLAINT|Niski'),
}

export const complaintPriorities = Object.keys(ComplaintPriorities).map((key) => ({
    value: key,
    label: ComplaintPriorities[key],
}));